import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import EthnicityService from "../../src/Services/Ethnicity.service";
const EthnicityLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<Ethnicity[]>' is not assignable to type '(ids: string[]) => Promise<Ethnicity[]>'.
        fetchItemsById: (ids) => {
            return EthnicityService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return EthnicityService.searchAll(search);
        },
        optionRenderer: function optionRenderer(ethnicity) {
            return _jsx("span", { children: ethnicity.name });
        },
    });
};
export default EthnicityLookup;
